import { ChangeEvent, ComponentProps, useEffect, useRef } from "react";
import { useFileInput } from "./Root";

export type ControlProps = ComponentProps<"input">;

export function Control({ multiple = false, ...props }: ControlProps) {
  const { id, onFilesSelected, onSetInputRef } = useFileInput();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef) {
      onSetInputRef(inputRef);
    }
  }, [inputRef, onSetInputRef]);

  function handleFilesSelected(event: ChangeEvent<HTMLInputElement>) {
    if (!event.target.files?.length) {
      return;
    }
    const file = Array.from(event.target.files);
    onFilesSelected(file, multiple);
  }
  return (
    <input
      ref={inputRef}
      type="file"
      className="tw-sr-only"
      id={id}
      onChange={handleFilesSelected}
      multiple={multiple}
      {...props}
    />
  );
}
